import { render, staticRenderFns } from "./CommonCallFromNext.vue?vue&type=template&id=1e6192d5"
import script from "./CommonCallFromNext.vue?vue&type=script&lang=js"
export * from "./CommonCallFromNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports